export default __webpack_public_path__ + "static/media/FaceSVG.f921dbd5.svg";